import React, { PropsWithChildren } from "react";

import { ParsedClassroom } from "@examspark/types";

export const ClassroomContext = React.createContext<
  ParsedClassroom | undefined
>(undefined);

const ClassroomProvider = (
  props: PropsWithChildren<{ classroom?: ParsedClassroom }>,
) => {
  return (
    <ClassroomContext.Provider value={props.classroom}>
      {props.children}
    </ClassroomContext.Provider>
  );
};

export default ClassroomProvider;
